import React from 'react';
import {
  Box,
  Button,
  alpha,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const TabContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
  borderRadius: '50px',
  padding: '4px',
  [theme.breakpoints.down('sm')]: {
    overflowX: 'auto',
    flexWrap: 'nowrap',
    width: '100%',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
}));

const TabButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ theme, active }) => ({
  borderRadius: '50px',
  padding: '8px 24px',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.95rem',
  [theme.breakpoints.down('sm')]: {
    padding: '6px 14px',
    fontSize: '0.8rem',
    flexShrink: 0,
  },
  color: active ? '#fff' : theme.palette.text.secondary,
  backgroundColor: active ? theme.palette.primary.main : 'transparent',
  boxShadow: active ? `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}` : 'none',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: active ? theme.palette.primary.dark : alpha(theme.palette.primary.main, 0.08),
  },
}));

const CategoryTabs = ({ categories, selectedTab, onTabChange, filterFn }) => {
  const displayCategories = filterFn ? categories.filter(filterFn) : categories;

  return (
    <TabContainer>
      {displayCategories.map((cat) => (
        <TabButton
          key={cat}
          active={selectedTab === cat}
          onClick={() => onTabChange(cat)}
          disableElevation
        >
          {cat}
        </TabButton>
      ))}
    </TabContainer>
  );
};

export default CategoryTabs;